<a
  (click)="clicked()"
  [attr.aria-label]="srText + ' help opens in new pop up'"
  [attr.role]="ariaRole"
  class="idp-icon-info-anchor"
  data-test-info-icon="true"
  href="javascript:void(0)"
>
  <i aria-hidden="true" class="idp-icon-info"></i>
  <span *ngIf="labelSrOnly" [innerHTML]="labelTitle" class="sr-only"></span>
  <span class="sr-only">opens in a new popup</span>
</a>
